import { connect } from "react-redux";

import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withMetrics } from "../../withMetrics";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withExternalMountingEventReporting } from "../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { checkIsSuitableToClick, externalOnClickHandler } from "../../../Engine/ActionCreators/ExternalOnClickAction";

import { PopupTextArea } from "./PopupTextArea";

interface PopupTextAreaOwnProps {
    bindingPath: AbsoluteResolvedModelPath;
    disabled?: boolean;
    disabled2?: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    viewModelSelect: ViewModelSelect;
    auto?: boolean;
    autoValue?: string;
}

const mapStateToProps = (state: FullFormState, ownProps: PopupTextAreaOwnProps) => {
    const { bindingPath, disabled, viewModelSelect, processEvaluableProp, disabled2, auto } = ownProps;
    const controlModel = viewModelSelect.controlModel(state, bindingPath);
    const autoFlag = auto && controlModel.autoFlag;

    return {
        value: (autoFlag ? controlModel.autoValue : controlModel.value) ?? "",
        autoFlag: autoFlag,
        autoValue: controlModel.autoValue,
        disabled: processEvaluableProp(state, disabled2) || (disabled ?? controlModel.disabled),
        error: controlModel.error,
        warning: controlModel.warning,
        isTooltipEnabled: controlModel.isTooltipEnabled,
        isReadOnly: state.settings.isReadOnly,
        isLink: checkIsSuitableToClick(state.settings, bindingPath),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: PopupTextAreaOwnProps) => {
    const { bindingPath } = ownProps;

    return {
        onChange: (value: string) => dispatch(setToModel(bindingPath, "value", value)),
        onClick: () => externalOnClickHandler(dispatch, bindingPath),
    };
};

export const PopupTextAreaContainer = withMetrics(
    withResolvePaths(
        withViewModelSelect(
            withEvaluators(
                connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(
                    withTestPageObjectRegistration(
                        withFocusManagement(withExternalMountingEventReporting(withControlDebugInfo(PopupTextArea)))
                    )
                )
            )
        )
    )
);
